import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.string.sub.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import Vue from 'vue';
import { cloneData } from 'src/_mixins/CommonMethods';
export default {
  makeKey: function makeKey(state, context) {
    return function (payload) {
      payload = cloneData(payload);
      delete payload.mode;
      delete payload.view_mode;
      delete payload.period;
      return Object.values(payload).join('-');
    };
  },
  getGNB: function getGNB(state) {
    return state.gnb;
  },
  getMainGNB: function getMainGNB(state) {
    return state.gnb.map(function (row) {
      return {
        'name': row.name,
        'code': row.code,
        'page': row.page,
        'endpoint': row.endpoint,
        'comment': row.comment
      };
    });
  },
  getCurrentMainGNB: function getCurrentMainGNB(state, context) {
    var cate = vm.$route.params.cate;
    if (!cate) {
      var routePathArr = vm.$route.path.split('/');
      cate = routePathArr[1];
    }
    var currentGNB = state.gnb.find(function (row) {
      return row.code && row.code === cate;
    });
    var routeExists = vm.$router.options.routes.some(function (route) {
      return route.path.endsWith("/".concat(cate));
    });
    if (!currentGNB && !routeExists) {
      // window.location.href = '/home'
    }
    return cate ? currentGNB : null;
  },
  getCurrentGNB: function getCurrentGNB(state, context) {
    var _vm$$route$params = vm.$route.params,
      main = _vm$$route$params.main,
      sub = _vm$$route$params.sub;
    var node = context.getCurrentMainGNB;
    if (node && node.sections && main) {
      node = node.sections.find(function (row) {
        return row.code === main;
      });
      if (node && node.sections && sub) {
        node = node.find(function (row) {
          return row.code === sub;
        });
      }
    }
    return node;
  },
  getCategories: function getCategories(state) {
    return state.categories;
  },
  getCategoriesCnt: function getCategoriesCnt(state, context) {
    return context.getCategories.length;
  },
  getActiveCategories: function getActiveCategories(state, context) {
    return context.getCategories.filter(function (row) {
      return row.is_visible;
    });
  },
  getLatestPosts: function getLatestPosts(state, context) {
    return Object.keys(state.latestPosts).length > 0 ? state.latestPosts : _objectSpread(_objectSpread({}, context.getPaginationOrigin), {}, {
      perPage: state.perPage.latest
    });
  },
  isLatestPostsFinish: function isLatestPostsFinish(state, context) {
    return context.getLatestPosts.total === context.getLatestPosts.data.length;
  },
  getChartPostsForHome: function getChartPostsForHome(state, context) {
    return function (forceKey) {
      return context.getChartPostsWithKey(forceKey).data.slice(0, 5);
    };
  },
  getPaginationOrigin: function getPaginationOrigin(state) {
    return cloneData(state.paginationOrigin);
  },
  makeCatePostKey: function makeCatePostKey() {
    var cate = vm.$route.params.cate;
    var _vm$$route$params2 = vm.$route.params,
      main = _vm$$route$params2.main,
      sub = _vm$$route$params2.sub;
    if (!cate) {
      var routePathArr = vm.$route.path.split('/');
      cate = routePathArr[1];
    }
    return "cate_".concat(cate, "_").concat(main, "_").concat(sub);
  },
  makeChartPostKey: function makeChartPostKey() {
    var _vm$$route$params$cat, _vm$$route$params$mai, _vm$$route$params$sub;
    var cate = (_vm$$route$params$cat = vm.$route.params.cate) !== null && _vm$$route$params$cat !== void 0 ? _vm$$route$params$cat : '';
    var main = (_vm$$route$params$mai = vm.$route.params.main) !== null && _vm$$route$params$mai !== void 0 ? _vm$$route$params$mai : 'trend';
    var sub = (_vm$$route$params$sub = vm.$route.params.sub) !== null && _vm$$route$params$sub !== void 0 ? _vm$$route$params$sub : '';
    if (!cate) {
      var routePathArr = vm.$route.path.split('/');
      cate = routePathArr[1];
    }
    return "cate_".concat(cate, "_").concat(main, "_").concat(sub);
  },
  getChartPosts: function getChartPosts(state, context) {
    var key = context.makeChartPostKey;
    var chartPosts = cloneData(state.chartPosts);
    return Object.keys(chartPosts).findIndex(function (row) {
      return row === key;
    }) > -1 ? chartPosts[key] : _objectSpread(_objectSpread({}, context.getPaginationOrigin), {}, {
      perPage: state.perPage.chart
    });
  },
  getChartPostsWithKey: function getChartPostsWithKey(state, context) {
    return function (forceKey) {
      var key = forceKey;
      var chartPosts = cloneData(state.chartPosts);
      return Object.keys(chartPosts).findIndex(function (row) {
        return row === key;
      }) > -1 ? chartPosts[key] : _objectSpread(_objectSpread({}, context.getPaginationOrigin), {}, {
        perPage: state.perPage.chart
      });
    };
  },
  isChartPostsFinish: function isChartPostsFinish(state, context) {
    return context.getChartPosts.total === context.getChartPosts.data.length;
  },
  getCatePosts: function getCatePosts(state, context) {
    var _vm$$route$params3 = vm.$route.params,
      main = _vm$$route$params3.main,
      sub = _vm$$route$params3.sub;
    var key = context.makeCatePostKey;
    var path = context.getCurrentGNB && context.getCurrentGNB.path ? JSON.parse(context.getCurrentGNB.path) : '';
    var catePosts = cloneData(state.catePosts);
    var rootData = Object.keys(catePosts).findIndex(function (row) {
      return row === key;
    }) > -1 ? catePosts[key] : _objectSpread(_objectSpread({}, context.getPaginationOrigin), {}, {
      perPage: state.perPage.cate
    });
    //notice - api 호출을 한번만 해서 필터링하는 방식 하지만, 개별 more 버튼의 구현이 어려워 각기 api 호출 방식을 사용
    // if (main || sub) {
    //   let data = rootData.data.filter(row =>
    //     row.post_cate.some(post_cate =>
    //       post_cate.join(',') === path[0].join(',')
    //     ))
    //   return {loading: false, total: data.length, page: rootData.page, data: data}
    // }
    return rootData;
  },
  isCatePostsFinish: function isCatePostsFinish(state, context) {
    return context.getCatePosts.total === context.getCatePosts.data.length;
  },
  getCurrentCate: function getCurrentCate(state) {
    return state.currentCate;
  },
  getTagPosts: function getTagPosts(state, context) {
    var key = "tag_".concat(vm.$route.params.tag);
    return state.tagPosts[key] ? state.tagPosts[key] : context.getPaginationOrigin;
  },
  isTagPostsFinish: function isTagPostsFinish(state, context) {
    return context.getTagPosts.total === context.getTagPosts.data.length;
  },
  getEditorPosts: function getEditorPosts(state, context) {
    var key = "editor_".concat(vm.$route.params.idx);
    return state.editorPosts[key] ? state.editorPosts[key] : context.getPaginationOrigin;
  },
  isEditorPostsFinish: function isEditorPostsFinish(state, context) {
    return context.getEditorPosts.total === context.getEditorPosts.data.length;
  },
  getCurrentEditor: function getCurrentEditor(state) {
    return state.currentEditor;
  },
  getSearchArticles: function getSearchArticles(state, context) {
    var key = "search_articles_".concat(vm.$route.params.keyword);
    return state.searchArticles[key] ? state.searchArticles[key] : context.getPaginationOrigin;
  },
  isSearchArticlesFinish: function isSearchArticlesFinish(state, context) {
    return context.getSearchArticles.total === context.getSearchArticles.data.length;
  },
  getDisplayCateData: function getDisplayCateData(state) {
    return state.displayCateData;
  },
  getDisplayCateDataCnt: function getDisplayCateDataCnt(state) {
    return state.displayCateData.length;
  },
  getDisplayData: function getDisplayData(state) {
    return state.displayData;
  },
  getDisplayPage: function getDisplayPage(state) {
    return state.displayPage;
  },
  makeDisplayPagekey: function makeDisplayPagekey() {
    return function (page) {
      var key = page;
      if (page === 'ArticleCate') {
        var _vm$$route$params$cat2, _vm$$route$query$main, _vm$$route$params$sub2;
        var cate = (_vm$$route$params$cat2 = vm.$route.params.cate) !== null && _vm$$route$params$cat2 !== void 0 ? _vm$$route$params$cat2 : '';
        var main = (_vm$$route$query$main = vm.$route.query.main) !== null && _vm$$route$query$main !== void 0 ? _vm$$route$query$main : '';
        var sub = (_vm$$route$params$sub2 = vm.$route.params.sub) !== null && _vm$$route$params$sub2 !== void 0 ? _vm$$route$params$sub2 : '';
        if (cate) key = key + "_".concat(cate);
        if (main) key = key + "_".concat(main);
        if (sub) key = key + "_".concat(sub);
      }
      return key;
    };
  },
  isExistDisplayPage: function isExistDisplayPage(state, context) {
    return function (page) {
      return state.displayPage.includes(context.makeDisplayPagekey(page));
    };
  },
  isExistDisplaySubMiddleBanner: function isExistDisplaySubMiddleBanner(state, context) {
    return context.getDisplayData.find(function (row) {
      return row.section.idx === 313;
    });
  },
  isUpdatedDisplayData: function isUpdatedDisplayData(state) {
    return state.isUpdatedDisplayData;
  },
  getDisplayDataCnt: function getDisplayDataCnt(state) {
    return state.displayData.length;
  },
  getDisplayDataFromDB: function getDisplayDataFromDB(state, context) {
    return function (payload) {
      if (!context.isExistDisplayPage(payload.page)) {
        var params = {
          params: {
            access: payload.access,
            page: payload.page
          }
        };
        if (params.params.page === 'ArticleCate') params.params.post_cate_code = vm.$route.params.cate;
        var action = '/displays';
        var key = context.makeDisplayPagekey(payload.page);
        vm.$store.dispatch('setDisplayPage', key).then(function () {
          vm.$axios.get(action, params).then(function (rs) {
            vm.$store.dispatch('setDisplayData', rs.data);
          });
        });
      }
    };
  },
  isExistListOfCalledAPI: function isExistListOfCalledAPI(state) {
    var rtn = function rtn(api) {
      return state.listOfCalledAPI.indexOf(api) > -1;
    };
    return rtn;
  },
  isToastBannerSmallSize: function isToastBannerSmallSize(state) {
    return state.smallToastBanner;
  },
  isOpenShareDialog: function isOpenShareDialog(state) {
    return state.openShareDialog;
  },
  getCurrentContentsData: function getCurrentContentsData(state) {
    return state.currentContentsData;
  },
  isOpenFooter1Dialog: function isOpenFooter1Dialog(state) {
    return state.openFooter1Dialog;
  },
  isOpenFooter2Dialog: function isOpenFooter2Dialog(state) {
    return state.openFooter2Dialog;
  },
  isOpenFooter3Dialog: function isOpenFooter3Dialog(state) {
    return state.openFooter3Dialog;
  },
  isOpenFaqDialog: function isOpenFaqDialog(state) {
    return state.openFaqDialog;
  },
  isOpenTeamDialog: function isOpenTeamDialog(state) {
    return state.openTeamDialog;
  },
  getFroalaAlertText: function getFroalaAlertText(state) {
    return state.froalaAlertText;
  }
};